import styled from 'styled-components';
import { Link, animateScroll as scroll } from "react-scroll";
import { globalStore } from '../../AppManager';
import { useEffect } from 'react';
import GetNavigationList from '../../data/navigation-list';
import HomeIcon from "../../res/icons/home.svg";
import Logo from '../../res/images/logo.png';
import FilledButton from '../buttons/FilledButton';
import MenuButton from './MenuButton';

const Container = styled.nav.attrs({ className: "mobile-nav" })`
    position: fixed;
    width: 100%;
    height: 8rem;
    top: 0;
    left: 0;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(10px);
    flex-shrink: 0;
    transition: 0.3s;
    box-sizing: border-box;
    border-left: 4px solid var(--yellow);
    box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.5);
    z-index: 5;
    display: none;
    align-items: center;
    justify-content: space-between;

    #logo-container {
        width: 280px;
        align-self: stretch;
        background-image: url(${Logo});
        background-size: 75%;
        background-position: center;
        background-repeat: no-repeat;
    }

    #menu-button-holder {
        width: 8rem;
        height: 8rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 2px solid var(--muted);
    }

    #nav-content {
        position: fixed;
        top: 8rem;
        left: -4px;
        width: calc(100% + 4px);
        box-sizing: border-box;
        display: ${({ menuIsVisible }) => menuIsVisible ? "flex" : "none"};
        flex-direction: column;
        align-items: center;
        justify-content: space-evenly;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 0.8);
        border-left: 4px solid var(--dark-yellow);
        box-shadow: 0 4px 6px -2px rgba(0, 0, 0, 0.5);

        .nav-item {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
            align-items: start;
            justify-content: center;
            cursor: pointer;
            width: 100%;
            height: 4rem;
            border-bottom: 1px solid var(--muted);
            box-sizing: border-box;
            padding: 0 1rem;

            img {
                width: 3rem;
                height: 3rem;
                box-sizing: border-box;
                padding: 0.5rem;
                border-bottom: 1px solid var(--black);
                border-top: 1px solid transparent;
                border-left: 1px solid transparent;
                border-right: 1px solid transparent;
                transition: 0.3s;
                display: none;
            }

            h6 {
                color: var(--black);
            }

            &:hover {
                background: var(--white);
            }

            &:hover h6 {
                color: var(--yellow);
            }

            &:hover img {
                border-color: var(--black);
            }
        }

        .active {
            img {
                background: var(--dark-white);
                border-color: var(--black);
            }
        }
    }

    @media screen and (max-width: 650px) {
        display: flex;
    }
`

export default function MobileNav() {

    const { visible, setVisible } = globalStore((state) => state.navigation);

    useEffect(() => {
        let section_headers = document.getElementsByClassName("section-header");

        for (var i = 0; i < section_headers.length; i++)
            section_headers[i].id = `section-header${i + 1}`;
    }, [])

    return (
        <Container menuIsVisible={visible}>

            <div id='logo-container'></div>
            <div id='menu-button-holder'><MenuButton /></div>

            <div id='nav-content'>

                <Link
                    activeClass='active'
                    containerId='app-content'
                    spy={true}
                    smooth={true}
                    duration={1000}
                    className='nav-item'
                    onClick={() => {
                        scroll.scrollTo(0, { containerId: 'app-content', duration: 1000, delay: 300 }); setVisible(false)
                    }
                    }>

                    <img src={HomeIcon} />
                    <h6> Home </h6>

                </Link>

                {
                    GetNavigationList().map((item) =>
                        <Link
                            activeClass='active'
                            containerId='app-content'
                            to={item.to}
                            spy={true}
                            smooth={true}
                            duration={1000}
                            delay={300}
                            className='nav-item'
                            onClick={() => setVisible(false)}>

                            <img src={item.icon} />
                            <h6> {item.text} </h6>

                        </Link>
                    )
                }

            </div>

        </Container>
    )
}